import * as React from 'react'
import { Download } from '../typings/download'
import Link from '../components/link/Link'
import { OSType } from '../typings/platforms'
import MetaTags from '../components/meta_tags/meta_tags'

type Context = {
  downloads: Download[]
  androidApk: string
  title: string
  description: string
}

const DownloadPage = ({ pageContext: { downloads, androidApk } }: { pageContext: Context }): JSX.Element => {
  return (
    <div className={'download-page'}>
      <section className={'center-align'}>
        <div className={'container full low-padding text-content horizontal-blocks'}>
          {downloads.map((download) => (
            <div key={download.name} className={'h-block center'}>
              <img src={`${download.app_icon}`} aria-hidden={'true'} />
              <h2>Standard Notes for {download.name}</h2>
              <p className={'mt-10'}>
                <Link to={download.link}>Begin Download</Link>
              </p>
              {download.name.toLowerCase() === OSType.LINUX && download.link_32 && (
                <>
                  <p>
                    <Link to={download.link_32}>32-bit download</Link>
                  </p>
                  <hr className={'mt-30'} />
                  <div className={'mt-20'}>
                    <h3>Linux AppImage Instructions:</h3>
                    <p>To run the AppImage file, simply:</p>
                    <pre>chmod a+x standard-notes---.AppImage</pre>
                    <pre>./standard-notes---.AppImage</pre>
                  </div>
                </>
              )}
              {download.name.toLowerCase() === OSType.ANDROID && (
                <div className={'mt-30'}>
                  <p>Don't want to use Google Play?</p>
                  <p>
                    <Link to={androidApk}>Download the APK directly.</Link>
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
      <hr />
    </div>
  )
}

export default DownloadPage

export const Head = ({ pageContext: { title, description, downloads } }: { pageContext: Context }) => {
  return (
    <MetaTags
      description={description}
      title={title}
      canonical={{ relative: downloads.length === 1 ? `/download/${downloads[0].platform}` : '/download' }}
    />
  )
}
